import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { QueryClientProvider } from '@tanstack/react-query';
import { RouterProvider } from 'react-router-dom';
import { FilePreviewHost, Toaster } from '@proerp/ui';
import { router } from './App';
import { AuthGate } from './components/AuthGate';
import { queryClient } from './lib/queryClient';
import { initTheme } from './lib/theme';
import { initTextSize } from './lib/textSize';
import './index.css';

initTheme();
initTextSize();

const rootElement = document.getElementById('root');
if (!rootElement) {
  throw new Error('Root-Element #root nicht gefunden.');
}

createRoot(rootElement).render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <AuthGate>
        <RouterProvider router={router} />
      </AuthGate>
      <Toaster />
      {/* Einbau-Punkt der Datei-Vorschau (ADR 0075). Genau einer für die ganze
          App — geöffnet wird sie von überall per `openFilePreview()`. */}
      <FilePreviewHost />
    </QueryClientProvider>
  </StrictMode>,
);
